import React from "react";
import LoginGitHub from "./LoginGithub"

import {
  DISPLAY_STRING_GH
  } from "../../utils/serviceName";

const GithubRankingHeading = function ({setToken, uuidCredit}) {
  return <>
    <div className="gitHub-ranking-heading" style={{borderTop: uuidCredit !== '' ? "" : "2px solid #2e3a59", padding: uuidCredit !== "" ? "" : "10px 20px"}}>
      <div className="username-title">
        <h3>
          <span>
          Are you a developer? <small style={{fontWeight: "normal"}}>Check your {DISPLAY_STRING_GH} rank then stand out by sharing a free verified credential proving ownership of your {DISPLAY_STRING_GH} to LinkedIn</small>
          </span>
        </h3>
      </div>
      <span id="btn-authorize-gitHub" style={{order: "2"}} className="btn-login">
        <div>
          <LoginGitHub onCode={setToken} />
          <p style={{textAlign: "center"}}>No signup required!<a href="https://linkedin.com/in/hinesystems" target="_blank">Example</a>(scroll down to Licenses & certifications)</p>
        </div>
      </span>
    </div>
  </>
}

export default GithubRankingHeading